import { useListAccountsQuery } from "features/trading/accounts";
import { getLastStatisticAccountId } from "helpers";

export const useAccountQuery = () => {
  const lastAccountId = getLastStatisticAccountId();

  return useListAccountsQuery({
    pagination: { page: 0, pageSize: 1 },
    filters: {
      id: lastAccountId || undefined
    }
  }, {
    selectFromResult: ({ data, ...rest }) => ({
      data: data?.results?.[0] || null,
      ...rest
    })
  });
};
